import { ready } from "~/core";

ready("metricCards", ".metricCards", (metricCards) => {
  console.log("metricCards", metricCards);
});
